import {
    Button,
    Card,
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTrigger,
    cn,
} from '@repo/shadcn';
import { useRef, useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { TextField } from '@components/form/fields';

import { TCreateExpiredStockAdjustment } from '@/modules/adjustment/expired-stock-adjustment/create/schema';
import { formatCurrencyInBDT } from '@/utils';

export const OverviewAndSubmit = () => {
    const { watch } = useFormContext<TCreateExpiredStockAdjustment>();

    const supplierId = watch('supplier_id');

    const submitButtonRef = useRef<HTMLButtonElement | null>(null);

    const [isOpen, setIsOpen] = useState(false);

    const handleConfirmRestock = () => {
        submitButtonRef.current?.click();
    };

    const items = watch('items') || [];
    const totalPaidAmount = watch('total_paid_amount') || 0;

    const totalPurchasePrice = items.reduce(
        (acc, item) => acc + (item.purchasePrice ?? 0) * (item.quantity ?? 0),
        0,
    );

    const totalUpdatedPrice = items.reduce(
        (acc, item) =>
            acc + (item.updatedPurchasePrice ?? 0) * (item.quantity ?? 0),
        0,
    );

    const totalPayableAmount = totalUpdatedPrice - totalPurchasePrice;

    const totalDue = totalPayableAmount - totalPaidAmount;

    const renderTotal = () => {
        return (
            <div className="flex flex-col items-end justify-center border-r-[1px] border-black pr-2">
                <p className={'text-nowrap'}>
                    Total Price:{' '}
                    <strong className={''}>
                        {formatCurrencyInBDT(totalPayableAmount)}
                    </strong>
                </p>

                <small
                    className={cn(
                        'text-nowrap',

                        totalDue >= 0 ? 'text-green-600' : 'text-red-600',
                    )}
                >
                    Due Amount:{' '}
                    <strong className={''}>
                        {formatCurrencyInBDT(totalDue)}
                    </strong>
                </small>
            </div>
        );
    };

    const isDisabled =
        items.length === 0 || totalPayableAmount < 0 || !supplierId;

    return (
        <Card
            className={
                'absolute bottom-0 right-0 col-span-2 flex w-full flex-row items-center justify-between gap-4 p-2'
            }
        >
            <div
                className={
                    'flex grow flex-row items-center justify-between gap-2'
                }
            >
                <p className={'text-nowrap pr-2'}>
                    Total Items:{' '}
                    <strong className={''}>{items?.length || 0}</strong>
                </p>
                {renderTotal()}
            </div>

            <div className={'flex items-center justify-end gap-2'}>
                <div className={'text-nowrap'}>Paid Amount:</div>
                <TextField<TCreateExpiredStockAdjustment>
                    name={'total_paid_amount'}
                    placeholder={'Enter paid amount'}
                    className={'w-full text-right'}
                    inputClass={'text-right ring-0'}
                    // label={'Paid Amount'}
                />

                <Dialog open={isOpen} onOpenChange={setIsOpen}>
                    <DialogTrigger asChild>
                        <Button
                            type={'button'}
                            variant={'default'}
                            disabled={isDisabled}
                        >
                            Purchase
                        </Button>
                    </DialogTrigger>

                    <DialogContent>
                        <DialogHeader>
                            <h3 className={'text-lg font-bold'}>
                                Are you sure you want to convert this to
                                purchase?
                            </h3>
                        </DialogHeader>
                        <div className={'mt-4 flex justify-end gap-2'}>
                            <Button
                                className={''}
                                type={'button'}
                                variant={'outline'}
                                onClick={() => setIsOpen(false)}
                            >
                                Cancel
                            </Button>
                            <Button
                                type={'button'}
                                onClick={handleConfirmRestock}
                            >
                                Confirm
                            </Button>
                        </div>
                    </DialogContent>
                </Dialog>

                <button
                    type={'submit'}
                    className={'hidden'}
                    ref={submitButtonRef}
                ></button>
            </div>
        </Card>
    );
};

OverviewAndSubmit.displayName = 'OverviewAndSubmit';
